import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// From slice — UI state & reducers
import {
  setSubjectName,
  toggleClassSelection,
  clearEdit,
  setShowForm,
} from "../redux/subjectSlice";

// From thunks — API calls
import {
  saveSubject,
  fetchClasses,
} from "../redux/subjectThunk";


const SubjectForm = () => {
  const dispatch = useDispatch();
  const { subjectName, selectedClassIds, classes, editingSubject, loading } = useSelector((state) => state.subject);

  useEffect(() => {
    dispatch(fetchClasses());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(saveSubject())
      .unwrap()
      .then(() => dispatch(setShowForm(false)))
      .catch((err) => alert(err));
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>Subject Name</label>
      <input
        value={subjectName}
        onChange={(e) => dispatch(setSubjectName(e.target.value))}
        disabled={loading}
        placeholder="Enter subject name"
      />
      <label>Associated Classes</label>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {classes
          .filter((c) => c.status)
          .map((cls) => (
            <button
              key={cls.class_id}
              type="button"
              disabled={loading}
              onClick={() => dispatch(toggleClassSelection(cls.class_id))}
              style={{
                backgroundColor: selectedClassIds.includes(cls.class_id) ? "#2563eb" : "#e5e7eb",
                color: selectedClassIds.includes(cls.class_id) ? "#fff" : "#000",
                border: "none",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              {cls.class_name}
            </button>
          ))}
      </div>
      <div style={{ marginTop: "10px" }}>
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : editingSubject ? "Update" : "Add"} Subject
        </button>
        <button type="button" onClick={() => {
          dispatch(clearEdit());
          dispatch(setShowForm(false));
        }}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default SubjectForm;
